import { useSnapshot } from "valtio/react";
import { loginState } from "@/states.ts";
import { LoginPage } from "@/pages/LoginPage.tsx";
import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "wouter";
import { RegistrationPage } from "@/pages/RegistrationPage.tsx";
import { useIsMobile } from "@/hooks/use-mobile.tsx";
import { MobileListsPage } from "@/pages/MobileListsPage.tsx";
import { DesktopPage } from "@/pages/DesktopPage.tsx";
import { MobileItemsPage } from "@/pages/MobileItemsPage.tsx";
import { Dialogs } from "@/dialogs/Dialogs.tsx";
import { getGroups, getList, getLists } from "@/api/offline.ts";
import { RecoverPasswordPage } from "@/pages/RecoverPasswordPage.tsx";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage.tsx";
import { DesktopSettingsPage } from "@/pages/DesktopSettingsPage.tsx";
import { MobileSettingsPage } from "@/pages/MobileSettingsPage.tsx";
import { fetchUser } from "@/api/user_api.ts";
import { VoiceAddButton } from "@/components/VoiceAddButton.tsx";

function App() {
	return (
		<Switch>
			<Route path="/login" component={LoginPage} />
			<Route path="/register" component={RegistrationPage} />
			<Route path="/recover-password" component={RecoverPasswordPage} />
			<Route path="/reset-password" component={ResetPasswordPage} />
			<Route path="/" component={ProtectedRoutes} nest />
		</Switch>
	);
}

const ProtectedRoutes = () => {
	const loginSnap = useSnapshot(loginState);
	const isLoggedIn = !!loginSnap.token || !!loginSnap.shareToken;
	const isMobile = useIsMobile();
	const [location, setLocation] = useLocation();

	useEffect(() => {
		if (isLoggedIn) {
			if (loginSnap.token) {
				getLists();
				getGroups();
				fetchUser()
					.then((r) => {
						loginState.user = r.user;
					})
					.catch(() => {});
			} else if (loginSnap.shareToken) {
				const urlParts = window.location.pathname.split("/");
				const listIdIndex = urlParts.indexOf("lists") + 1;
				if (listIdIndex > 0 && urlParts[listIdIndex]) {
					getList(urlParts[listIdIndex]);
				}
			}
		} else if (isLoggedIn === false) {
			setLocation("/login");
		}
	}, [isLoggedIn, loginSnap.token, loginSnap.shareToken]);

	if (isMobile === undefined) {
		return null;
	}

	if (!isLoggedIn) {
		return null;
	}
	const MainPage = isMobile ? MobileListsPage : DesktopPage;
	const ItemsPage = isMobile ? MobileItemsPage : DesktopPage;
	const SettingsPage = isMobile ? MobileSettingsPage : DesktopSettingsPage;

	return (
		<>
			<Dialogs />
			{loginSnap.user?.features?.includes("feature-voice") && <VoiceAddButton />}
			<Route path="/" component={MainPage} />
			<Route path="/lists/:listId/items" component={ItemsPage} />
			<Route path={"/settings"} component={SettingsPage} nest />
		</>
	);
};

export default App;
